import { Button, Hint } from '@factorialco/deprecated-design-system'
import { LOCAL_STORAGE_KEYS } from 'config/Vars'

import i18n from 'modules/core/lib/i18n'
import useLocalStorage from 'modules/core/lib/useLocalStorage'

type Props = {
  onClick: () => void
}

const UpsellContactButton = ({ onClick }: Props) => {
  const [showHint, setShowHint] = useLocalStorage<boolean>(
    LOCAL_STORAGE_KEYS.showPayrollPromoHint,
    true
  )

  const hintOnCloseHandler = () => {
    setShowHint(false)
  }

  const customOnClick = () => {
    if (showHint) hintOnCloseHandler()

    onClick()
  }

  return (
    <Hint.Popover.Provider
      steps={1}
      isHidden={!showHint}
      onClose={hintOnCloseHandler}
      onFinish={customOnClick}
    >
      <Hint.Popover
        step={1}
        title={i18n.t('payroll_bundle.upsell.product_services_promo.hint.title')}
        description={i18n.t('payroll_bundle.upsell.product_services_promo.hint.description')}
        actionLabel={i18n.t('payroll_bundle.upsell.product_services_promo.hint.button')}
        position="bottom left"
      >
        <Button type="secondary" onClick={customOnClick} iconName="question" />
      </Hint.Popover>
    </Hint.Popover.Provider>
  )
}

export default UpsellContactButton
